/* TODO: t() */
import React, { Component } from 'react';
import { BooleanInput, Checkbox } from '../../../uiold';

import { FormFieldDefinition } from '../../../../types/shared/FormFieldDefinition';

type Props = {
  definition: FormFieldDefinition;
  value: boolean | null | undefined;
  onChange?: (id: string, value: boolean) => void;
};

class BooleanElementEditView extends Component<Props> {
  static defaultProps = {
    value: false,
  };

  render() {
    let { definition, value } = this.props;
    // TODO: Better solution here.
    if (definition.type !== 'BooleanElement') {
      return null;
    }
    if (definition.use_checkbox) {
      return (
        <Checkbox
          isChecked={value ?? false}
          text={definition.label}
          onChange={this._toggleValue}
          style={{ paddingVertical: 0 }}
        />
      );
    }
    return <BooleanInput value={value ?? false} onChange={this._toggleValue} />;
  }

  _toggleValue = () => {
    this.props.onChange?.(this.props.definition.id, !this.props.value);
  };
}

export default BooleanElementEditView;
